import { USER_INFO_REQUEST, USER_INFO_SUCCESS, USER_INFO_FAILURE } from '../constants/user_info.constants';

const initialState = {
    loading: true,
    categories: [],
    user: null,
    get_reset_button: null,
    notifications: [],
    error: null,
    isAuthenticated: false,
};

export const App_content = (state = initialState, action) => {
    switch (action.type) {
    case USER_INFO_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case USER_INFO_SUCCESS:
        const divisions = action.payload.user_info?.divisions?.filter(division => division._id != '5f43b26aef2c7826be53fced'); // TRA (Trade)
        
        return {
            ...state,
            user: { ...action.payload.user_info, divisions },
            categories: [...action.payload.categories],
            loading: false,
            isAuthenticated: true,
        };
    case USER_INFO_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    case 'GROUPS_UPDATE':
        return {
            ...state,
            user: {
                ...state.user,
                groups: action.payload,
            },
        };
    case 'APP_NOTIFICATION':
        return {
            ...state,
            notifications: [...state.notifications, action.payload],
        };

    case 'FILTER_APP_NOTIFICATION':
        const vrm = action.payload.title.split(' ')[0];
        const option = action.payload.title.split(' ')[3];
        return {
            ...state,
            notifications: state.notifications.filter((note) => {
                if (!note.msg.startsWith(vrm)) {
                    if (!action.payload.title.includes('was approved') && !note.msg.includes(option)) {
                        return note;
                    }
                }
            }),
        };
    case 'CLEAR_APP_NOTIFICATIONS':
        return {
            ...state,
            notifications: [],
        };

    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/App/redux/reducers/app_content.reducers.js